import React from 'react';
import PropTypes from 'prop-types';

import timer from '../../config/timer.config';
import { MIndicators, MReferenceList } from '../molecules';

export default class OReferenceSlider extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			index: 0,
			prevIndex: props.items.length - 1,
		};

		this.bindHandles();
		this.timeOut = undefined;
		this.sections = [7, 14, 21];
	}

	componentDidMount() {
		this.startSlider();
	}

	componentWillUnmount() {
		clearTimeout(this.timeOut);
	}

	bindHandles() {
		this.handleBack = this.handleBack.bind(this);
		this.handleBackKeyDown = this.handleBackKeyDown.bind(this);
		this.handleNext = this.handleNext.bind(this);
		this.handleNextKeyDown = this.handleNextKeyDown.bind(this);
		this.goToNext = this.goToNext.bind(this);
	}

	handleBack() {
		if (this.sections.length < 2) {
			return;
		}

		this.setState(prev => ({
			index: prev.index - 1 === -1 ? this.sections.length - 1 : prev.index - 1,
			prevIndex: prev.index - 1 === -1 ? 0 : prev.index,
		}));

		clearTimeout(this.state.timeOut);
		this.startSlider();
	}

	handleBackKeyDown(event) {
		if (event.keyCode === 13) {
			this.handleBack();
		}
	}

	handleNext() {
		if (this.sections.length < 2) {
			return;
		}

		this.setState(prev => ({
			index: prev.index + 1 === this.sections.length ? 0 : prev.index + 1,
			prevIndex: prev.index + 1 === this.sections.length ? this.sections.length - 1 : prev.index,
		}));

		clearTimeout(this.timeOut);
		this.startSlider();
	}

	handleNextKeyDown(event) {
		if (event.keyCode === 13) {
			this.handleNext();
		}
	}

	goToNext() {
		this.setState(prev => ({
			index: prev.index + 1 === this.sections.length ? 0 : prev.index + 1,
			prevIndex: prev.index + 1 === this.sections.length ? this.sections.length - 1 : prev.index,
		}));
	}

	startSlider() {
		if (this.sections.length < 2) {
			return;
		}

		this.timeOut = setTimeout(() => this.handleNext(), timer.slider);
	}


	render() {
		return (
			<section className={`o-reference-slider ${this.props.className}`}>
				<article className="slider-list">
					{this.sections.map((items, index) => (
						<div className={`slider-body ${this.state.prevIndex === index ? 'previous' : ''}
						${this.state.index === index ? 'active' : ''}`}
						>
							<MReferenceList items={this.props.items.slice(items - this.sections[0], items)} />
						</div>))}
				</article>
				<MIndicators
					amount={this.sections.length}
					value={this.state.index}
					className="slider-indicators"
				/>
			</section >
		);
	}
}

OReferenceSlider.propTypes = {
	items: PropTypes.array.isRequired,
	className: PropTypes.string,
};

OReferenceSlider.defaultProps = {
	className: '',
};




// WEBPACK FOOTER //
// ./src/components/organisme/_organisme.reference-slider.js